import React from "react"
import parse from "html-react-parser"
import ImageGallery from "../ImageGallery/ImageGallery"

export function parseContent(content) {
  if (typeof window === "undefined") return null // safety check for SSR

  // Use html-react-parser to parse the content
  const parsedContent = parse(content, {
    replace: ({ attribs, children, next }) => {
      if (attribs?.class?.includes("wp-block-gallery")) {
        const images = Array.from(children[0]?.children).map(
          imgNode => imgNode?.children[0]?.children[0]?.attribs
        )

        const caption = children[1]?.children[0]?.data

        return <ImageGallery images={images} caption={caption} />
      }
    },
  })

  return parsedContent
}
